import Vue from 'vue'
import 'default-passive-events' //让页面滑动流畅得飞起的新特性
import './router/premit' //没有暴露 直接引用即可
import './directive/hasPermi' //自定义指令
import emelent from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'//这里无需引入element-ui的css
// import '@/assets/styles/element-variables.scss'


//引入后续自定义 阿里图标
import '@/assets/icons/iconfont.css'
import Print from 'vue-print-nb'
Vue.use(Print)
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import mixin from '@/mixin'
import global from './utils/global' //全局组件,变量js
// import '../theme/index.css'
Vue.use(global)
Vue.prototype.bus = new Vue() //总线
Vue.config.productionTip = false

Vue.use(emelent, {
	size: localStorage.getItem('size') || 'medium' // set element-ui default size
})
Vue.mixin(mixin)

// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
  
// Vue.use(VueQuillEditor);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
